import produce from 'immer'
import { Reducer } from 'redux';

import {
  SET_ANNOTATIONS_COMMENTS_LOADED,
  SET_ANNOTATIONS_IS_COMMENTS_FILTERED
} from 'redux/actions/types'

interface AnnotationState {
  isCommentsLoaded:boolean;
  isFiltered:boolean;
}

const initialState: AnnotationState =  {
  isCommentsLoaded: false,
  isFiltered: false
}

const annotations:Reducer<AnnotationState, any> = (state = initialState, action:any) => {
  switch (action.type) {
    case SET_ANNOTATIONS_COMMENTS_LOADED:
      return produce(state, draft => {
        draft.isCommentsLoaded = action.isLoaded
      })
    case SET_ANNOTATIONS_IS_COMMENTS_FILTERED:
      return produce(state, draft => {
        draft.isFiltered = action.isFiltered
      })
    default:
      return state
  }
}

export default annotations
